import $ from '@modules/jquery-import';

export const passwordRequirements = value => ({
    length: value.trim().length >= 8,
    number: /[0-9]/.test( value )
});

export function initPasswordForms () {
    $.validator.addMethod( 'accountPassword', value => {
        const requirements = passwordRequirements( value );
        return requirements.length && requirements.number;
    }, 'Use 8 or more characters and at least 1 number.' );

    document.querySelectorAll( '[data-password-form]' ).forEach( form => {
        if ( form.dataset.passwordInitialized ) {
            return;
        }
        form.dataset.passwordInitialized = 'true';
        form.dataset.hsIgnore = 'true';
        const password = form.querySelector( '[name="NewPassword"]' );
        const confirmation = form.querySelector( '[name="ConfirmPassword"]' );
        let submitted = false;
        const validator = $( form ).validate( {
            errorClass: 'password-field-error',
            rules: {
                Email: {required: true, email: true},
                CurrentPassword: {required: true},
                NewPassword: {required: true, accountPassword: true},
                ConfirmPassword: {required: true, equalTo: password}
            },
            messages: {
                NewPassword: {accountPassword: form.dataset.passwordPolicyMessage || 'Use 8 or more characters and at least 1 number.'},
                ConfirmPassword: {equalTo: form.dataset.passwordMismatchMessage || 'Password doesn’t match'}
            },
            errorElement: 'span',
            errorPlacement: ( error, element ) => {
                const target = form.querySelector( `[data-valmsg-for="${element[0].name}"]` );
                if ( target ) {
                    $( target ).empty().append( error );
                }
                else {
                    error.insertAfter( element );
                }
            },
            submitHandler: () => {
                if ( !submitted ) {
                    submitted = true;
                    form.querySelectorAll( '[type="submit"]' ).forEach( button => { button.disabled = true; } );
                    HTMLFormElement.prototype.submit.call( form );
                }
                return false;
            }
        } );

        const update = () => {
            if ( !password ) {
                return;
            }
            const requirements = passwordRequirements( password.value );
            Object.keys( requirements ).forEach( rule => {
                const item = form.querySelector( `[data-password-${rule}]` );
                if ( item ) {
                    item.classList.toggle( 'is-met', requirements[rule] );
                    const state = item.querySelector( '[data-requirement-state]' );
                    if ( state ) { state.textContent = requirements[rule] ? (form.dataset.metLabel || 'Met: ') : (form.dataset.unmetLabel || 'Not met: '); }
                }
            } );
            if ( confirmation && (confirmation.value || validator.submitted.ConfirmPassword) ) {
                validator.element( confirmation );
            }
        };
        form.addEventListener( 'input', update );
        form.addEventListener( 'change', update );
        window.addEventListener( 'pageshow', () => {
            submitted = false;
            form.querySelectorAll( '[type="submit"]' ).forEach( button => { button.disabled = false; } );
            update();
        } );
        update();
    } );
}

export function initPasswordSuccess ( root = document, navigate = url => window.location.assign( url ) ) {
    root.querySelectorAll( '[data-password-success]' ).forEach( panel => {
        if ( panel.dataset.countdownInitialized ) { return; }
        panel.dataset.countdownInitialized = 'true';
        const message = panel.querySelector( '[data-countdown-message]' );
        const counter = panel.querySelector( '[data-countdown]' );
        const stop = panel.querySelector( '[data-stop-countdown]' );
        let seconds = 5;
        counter.textContent = seconds;
        message.hidden = false;
        stop.hidden = false;
        const timer = window.setInterval( () => {
            counter.textContent = --seconds;
            if ( seconds === 0 ) {
                window.clearInterval( timer );
                navigate( '/' );
            }
        }, 1000 );
        const cancel = () => {
            window.clearInterval( timer );
            message.hidden = true;
            stop.hidden = true;
        };
        stop.addEventListener( 'click', cancel );
        window.addEventListener( 'pagehide', cancel, {once: true} );
    } );
}
